import React from 'react';
import {
  useMap,
  useMapsLibrary,
} from '@vis.gl/react-google-maps';

const MyFieldsWeightedAverageCircle = ({farmField}) => {

  const map = useMap();

  const mapsLib = useMapsLibrary('maps');

  const [circle, setCircle] = React.useState(null);

  React.useEffect(() => {
    if (map === null || mapsLib === null) {
      return;
    }
    if (farmField !== null && circle === null) {
      const c = new mapsLib.Circle({
        strokeColor: 'black',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#FF5F00',
        fillOpacity: 0.50,
        center: {
          lng: farmField.Longitude,
          lat: farmField.Latitude,
        },
        radius: 8046.72, // 5 miles in meters
      });
      c.setMap(map);
      setCircle(c);
    }
    else if (farmField !== null && circle !== null) {
      circle.setOptions({
        center: {
          lng: farmField.Longitude,
          lat: farmField.Latitude,
        },
      });
      circle.setMap(map);
    }
    else if (farmField === null && circle !== null) {
      circle.setMap(null);
    }
  }, [map, mapsLib, circle, farmField]);

  return null;
};

export default MyFieldsWeightedAverageCircle;
